export const SMALL_CACHE_TIME = 10 * 60 * 1000; // 10 minutes
export const MEDIUM_CACHE_TIME = 60 * 60 * 1000; // 60 minutes
export const LONG_CACHE_TIME = 12 * 60 * 60 * 1000; // 12 hours
export const X_LONG_CACHE_TIME = 24 * 60 * 60 * 1000; // 1 day
export const STALE_TIME_MS = 5 * 60_000;

export const DEFAULT_PER_PAGE = 50;
